module.exports = __webpack_public_path__ + "img/bb.71da99ed.svg";